import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UiColumn } from '../../ui/ui-column';
import { ColumnSetting } from '../../interfaces/column-setting.interface';
import { GridModule, SelectableSettings } from '@progress/kendo-angular-grid';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-grid-detail',
    imports: [GridModule, TranslateModule],
    templateUrl: './grid-detail.component.html',
    styleUrls: ['./grid-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridDetailComponent implements OnInit {

  @Input() dataItem: any;
  @Input() dataProperty?: string;
  @Input() columns?: UiColumn[] = [];

  public colSettings: ColumnSetting[] = [];
  public data: Array<any> = [];

  public selectableSettings: SelectableSettings;

  constructor() {

  }

  ngOnInit(): void {

    this.selectableSettings = {
      mode: "multiple",
      drag: true
    };

    if (this.dataProperty) {
      this.data = this.dataItem[this.dataProperty];
    }

    if (this.columns) {
      for (var i = 0; i < this.columns.length; i++) {
        var column = this.columns[i];
        const col: ColumnSetting =
        {
          field: column.field,
          title: column.title,
          width: column.size,
          type: column.type,
          hidden: column.hidden,
          aggregate: column.aggregate,
          editor: column.editor,
          editable: column.editor !== undefined,
          format: column.format
        }
        this.colSettings.push(col);
      }
    }
  }

  trackByColSetting(index: number, item: ColumnSetting): string {
    return item.field;
  }

}
